import type { PrivateEventDetail } from '../../api/privateEvents';

import {
  clientDealErrors,
  clientDealPatch,
  seedClientDeal,
  type ClientDealDraft,
} from './private-event-client-deal';
import { useSectionDraft } from './use-section-draft';

const RELATED: Partial<Record<keyof ClientDealDraft, string[]>> = {
  dealValue: ['dealValueCents'],
  depositReceived: ['hubspotPaymentId'],
};

export function useClientDealForm(event: PrivateEventDetail, onDenied: () => void) {
  return useSectionDraft<ClientDealDraft>({
    event,
    seed: seedClientDeal,
    patch: clientDealPatch,
    validate: clientDealErrors,
    related: RELATED,
    onDenied,
  });
}

export type ClientDealForm = ReturnType<typeof useClientDealForm>;
